import { render, staticRenderFns } from "./SideToolbar.vue?vue&type=template&id=7a4f9daf&scoped=true"
import script from "./SideToolbar.vue?vue&type=script&lang=ts"
export * from "./SideToolbar.vue?vue&type=script&lang=ts"
import style0 from "./SideToolbar.vue?vue&type=style&index=0&id=7a4f9daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f9daf",
  null
  
)

export default component.exports